import { forwardRef, type Ref, type SVGProps } from "react";
const IconListBulletedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6.79 0h13.42C27.195 9 28 8.1 28 7s-.805-2-1.79-2H12.79C11.805 5 11 5.9 11 7s.805 2 1.79 2m0 9h13.42c.985 0 1.79-.9 1.79-2s-.805-2-1.79-2H12.79c-.985 0-1.79.9-1.79 2s.805 2 1.79 2m13.42 9H12.79c-.985 0-1.79-.9-1.79-2s.805-2 1.79-2h13.42c.985 0 1.79.9 1.79 2s-.805 2-1.79 2M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
const ForwardRef = forwardRef(IconListBulletedFilledSVG);
ForwardRef.displayName = "IconListBulletedFilled";
export { ForwardRef as IconListBulletedFilled };
